module.exports = __webpack_public_path__ + "static/media/bg-1.de751556.jpg";